











































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrderData } from '@/api/types'
import { UserModule } from '@/store/modules/user'
import { addAppointmentDate } from '@/api/orders'

@Component({
  name: 'OrderProperty',
  components: {}
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IOrderData;

  private dialogAppointmentDate = false;
  private comment = '';
  private appointmentDate = null
  private appointmentDateComment = '';
  private latestAppointmentDateComment = '';

  data() {
    return {
      states: {
        AL: 'Alabama',
        AK: 'Alaska',
        AS: 'American Samoa',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FM: 'Federated States Of Micronesia',
        FL: 'Florida',
        GA: 'Georgia',
        GU: 'Guam',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MH: 'Marshall Islands',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        MP: 'Northern Mariana Islands',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PW: 'Palau',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VI: 'Virgin Islands',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming'
      },
      zipError: false,
      zipErrorMessage: '',
      pickerOptions: {
        disabledDate(time) {
          const now = new Date()
          now.setHours(0, 0, 0, 0)
          time.setHours(0, 0, 0, 0)
          return time < now
        }
      }
    }
  }

  get isAdmin() {
    return UserModule.roles.includes('Admin')
  }

  reseteZIPCodeErrors() {
    this.$data.zipErrorMessage = ''
    this.$data.zipError = false
  }

  validateZIPCode() {
    const validZIPRegex = /\d{5}/g
    const result = this.value['ZIP Code'].match(validZIPRegex)

    if (!result) {
      this.$data.zipError = true
      this.$data.zipErrorMessage = 'Invalid ZIP number'
    }
  }

  addNotes(): void {
    console.log(' verify address ')
  }

  addAppointmentDate() {
    console.log(this.appointmentDate)
    const request = addAppointmentDate(this.value.orderId, this.appointmentDate, this.appointmentDateComment)
    request.then((response) => {
      this.dialogAppointmentDate = false
      this.appointmentDate = null
      this.appointmentDateComment = ''
      this.$emit('update-order', response.data)
      this.$notify({
        title: 'Success',
        message: 'Appointement set succesfully',
        type: 'success',
        duration: 4000
      })
    })
  }
}
